import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const ChatBubbleOffIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M20 3.99997V16H18.66L20.57 17.91C21.39 17.66 22 16.9 22 16V3.99997C22 2.89997 21.1 1.99997 20 1.99997H4.66L6.66 3.99997H20ZM6 12H8V14H6V12ZM18 8.99997H11.66L13.66 11H18V8.99997ZM18 5.99997H10V7.33997L10.66 7.99997H18V5.99997ZM1.41 1.58997L0 2.99997L2.01 5.00997L2 22L6 18H15L20.73 23.73L22.14 22.32L1.41 1.58997ZM5.17 16L4 17.17V6.99997L6 8.99997V11H8L13 16H5.17Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
